import { CLEAR_SINGLE_BANNER, FETCH_SINGLE_BANNER, SET_SINGLE_BANNER } from "../actions";

export const getSingleCollection = (collectionId) => ({
    type: FETCH_SINGLE_BANNER,
    payload: { collectionId },
});

export const setBanner = (bannerData) => ({
    type: SET_SINGLE_BANNER,
    payload: bannerData,
});

export const clearBanner = () => ({
    type: CLEAR_SINGLE_BANNER,
});
